module.exports = __webpack_public_path__ + "static/sunday-26ef8da3dfa3861876f357983432aa44.jpg";